import React, { useEffect, useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import CategoryList from "./category-list";
import "./index.scss";
import SubCategoryList from "./sub-category-list";
import ItemList from "./item-list";
import VendorItemMap from "./vendor-item-map";
import Company from "./company";
import DepartmentList from "./department-list";
import VendorList from "./vendor-list";
import Locations from "./locations";
import ForeignCurrency from "./foreign-currency";
import ExtraCharges from "./extra-charges";
// import { isDepartmentUserRole } from "../../utils/common-utils";
import { hasDepartmentUserMasterAccess } from "../../utils/common-utils";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

const MasterData = () => {
  const [value, setValue] = useState(0);
  // const showAllMasterTabs = !isDepartmentUserRole();
  // PR PO RC is limited to the same Items/Vendors/Vendor Item Mapping tabs as DEPARTMENT USER.
  const showAllMasterTabs = !hasDepartmentUserMasterAccess();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="finance-v2-rm-pt finance-v2-budget-list">
      <div className="tabs-section">
        <Box>
          <Tabs variant="scrollable" value={value} onChange={handleChange}>
            <Tab value={0} label="Items" sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
            {showAllMasterTabs && (
              <Tab value={1} label="Category" sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
            )}
            {showAllMasterTabs && (
              <Tab value={2} label="Subcategory" sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
            )}
            <Tab value={3} label="Vendor Item Mapping" sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
            {showAllMasterTabs && (
              <Tab value={4} label="Company" sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
            )}
            <Tab value={5} label="Vendors" sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
            {showAllMasterTabs && (
              <Tab value={6} label="Departments" sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
            )}
            {showAllMasterTabs && (
              <Tab value={7} label="Locations" sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
            )}
            {showAllMasterTabs && (
              <Tab value={8} label="Foreign Currency" sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
            )}
            {showAllMasterTabs && (
              <Tab value={9} label="Extra Charges" sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
            )}
          </Tabs>
        </Box>
      </div>
      <TabPanel value={value} index={0}>
        <ItemList />
      </TabPanel>
      {showAllMasterTabs && (
        <TabPanel value={value} index={1}>
          <CategoryList />
        </TabPanel>
      )}
      {showAllMasterTabs && (
        <TabPanel value={value} index={2}>
          <SubCategoryList />
        </TabPanel>
      )}
      <TabPanel value={value} index={3}>
        <VendorItemMap />
      </TabPanel>
      {showAllMasterTabs && (
        <TabPanel value={value} index={4}>
          <Company />
        </TabPanel>
      )}
      <TabPanel value={value} index={5}>
        <VendorList />
      </TabPanel>
      {showAllMasterTabs && (
        <TabPanel value={value} index={6}>
          <DepartmentList />
        </TabPanel>
      )}
      {showAllMasterTabs && (
        <TabPanel value={value} index={7}>
          <Locations />
        </TabPanel>
      )}
      {showAllMasterTabs && (
        <TabPanel value={value} index={8}>
          <ForeignCurrency />
        </TabPanel>
      )}
      {showAllMasterTabs && (
        <TabPanel value={value} index={9}>
          <ExtraCharges />
        </TabPanel>
      )}
    </div>
  );
};

export default MasterData;
